import React from 'react';
import { compose } from 'ramda';
import { reduxForm, InjectedFormProps, Form } from 'redux-form';
import Forms from 'components/Forms';
import { Validators } from 'components/Forms/Validators';

interface FormProps {
  name: string;
  policyIndex: number;
  removeLocalPolicy: (id: number, existing?: boolean) => void;
  markAsSaved: (id: string) => void;
  isIoImport?: boolean;
  isIncomplete?: boolean;
  isComplete?: boolean;
}

const ManagePoliciesForm = ({
  form,
  removeLocalPolicy,
  policyIndex,
  markAsSaved,
  isIoImport = false,
  isIncomplete = false,
  isComplete = false
}: InjectedFormProps & FormProps) => {
  return (
    <Form>
      <Forms.ManagePolicies.Policy
        isIoImport={isIoImport}
        isIncomplete={isIncomplete}
        isComplete={isComplete}
        formName={form}
        removeLocalPolicy={removeLocalPolicy}
        policyIndex={policyIndex}
        markAsSaved={markAsSaved}
      />
    </Form>
  );
};

export default compose(
  reduxForm({ enableReinitialize: true, validate: Validators.existingPolicy })
)(ManagePoliciesForm);
